<div
  class="navigation_button"
  [ngClass]="{ 'navigation_button--expanded': expanded }"
  (click)="toggleMenu()">
  <span
    class="navigation_icon"
    [ngClass]="{ 'navigation_icon--expanded': expanded }">
  </span>
</div>

<div class="navigation_background" [ngClass]="{'navigation_background--expanded': expanded}"></div>
<nav class="navigation_navigation" [ngClass]="{'navigation_navigation--expanded': expanded}">
  <ul class="navigation_list">
    @if (!authService.isTechallUserOrAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/user_settings']"
          (click)="expanded = false">
          {{ 'profile' | translate | titlecase }}
        </a>
      </li>
    }
    @if (!authService.isTechallUserOrAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/patients']"
          (click)="expanded = false">
          {{ 'patients' | translate | titlecase }}
        </a>
      </li>
    }
    @if (!authService.isTechallUserOrAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/devices']"
          (click)="expanded = false">
          {{ 'manageDevices' | translate | titlecase }}
        </a>
      </li>
    }
    @if (authService.isHomeManagementEnabled && !authService.isTechallUserOrAdmin) {
      <li class="navigation_item">

        <a
          class="navigation_link"
          [routerLink]="['/home-management']"
          (click)="expanded = false">
          {{ 'homeManagement' | translate | titlecase }}
        </a>
      </li>
    }
    @if (authService.isOfficeGroupAdmin || (authService.isTechallAdmin && !!techallService.currentSession)) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/custom-bundles']"
          (click)="expanded = false">
          {{ 'manageCustomBundles' | translate | titlecase }}
        </a>
      </li>
    }
    @if (authService.isOfficeGroupAdmin || authService.isOfficeAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="[authService.isOfficeGroupAdmin ? '/offices' : '/users']"
          (click)="expanded = false">
          {{ authService.isOfficeGroupAdmin ? ('manageOffices' | translate | titlecase) : ('manageUsers' | translate | titlecase) }}
        </a>
      </li>
    }
    @if (authService.isTechallAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/waiting-sessions']"
          (click)="expanded = false">
          {{ 'manageSessions' | translate | titlecase }}
        </a>
      </li>
    }
    @if (!authService.isClinicalTrialReadOnlyNoPii && authService.isPacsIntegrationUser && !authService.isTechallUserOrAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/work-items']"
          (click)="expanded = false">
          {{ 'manageWorkItems' | translate | titlecase }}
        </a>
      </li>
    }
    @if (authService.isSupportUser) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/support/devices']"
          (click)="expanded = false">
          {{ 'reports' | translate | titlecase }}
        </a>
      </li>
    }
    @if (!authService.isClinicalTrialReadOnlyNoPii && !authService.isTechallUserOrAdmin && authService.isResearchModeEnabled && authService.isExportTasksAvailable) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/export-tasks']"
          (click)="expanded = false">
          {{ 'exportTasks' | translate | titlecase }}
        </a>
      </li>
    }
    @if (!authService.isTechallUserOrAdmin) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/preferences']"
          (click)="expanded = false">
          {{ 'preferences' | translate | titlecase }}
        </a>
      </li>
    }
    @if (authService.isDevMode) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/dev-settings']"
          (click)="expanded = false">
          Developer Settings
        </a>
      </li>
    }
    @if (!authService.isTechallUser || !techallService.currentSession) {
      <li class="navigation_item">
        <a
          class="navigation_link"
          [routerLink]="['/about']"
          (click)="expanded = false">
          {{ 'about' | translate | titlecase }}
        </a>
      </li>
    }
    <li class="navigation_item">
      <a
        class="navigation_link"
        href
        (click)="logout($event)">
        {{ 'logout' | translate | titlecase }}
      </a>
    </li>
  </ul>
</nav>

@if (isLoading) {
  <app-loader [transparent]="true"></app-loader>
}
